<template>
  <sea-page
    title="Documenti azienda"
    showCompanyHeader
    :selectCompany="activeProfile.role === 'ROLE_CONSULTANT'"
    :back="activeProfile.role === 'ROLE_CONSULTANT'"
    backPage="/consultant/documents/azi"
  >
    <v-tabs v-model="active">
      <v-tabs-slider></v-tabs-slider>

      <v-tab key="1">
        <v-icon left>mdi-inbox</v-icon>
        Generale
      </v-tab>
      <v-tab @click="clickTab()" key="2">
        <v-icon left>mdi-folder-plus-outline</v-icon>
        Fascicoli
      </v-tab>
      <v-tab key="3" v-if="activeProfile.role == authority.COMPANY.role">
        <v-icon left>mdi-account-multiple</v-icon>
        Richieste
      </v-tab>
      <v-tab key="4" v-if="activeProfile.role === authority.CONSULTANT.role">
        <v-icon left>mdi-account-multiple</v-icon>
        Richieste
      </v-tab>
      <v-tab-item>
        <v-card flat><generici></generici></v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat><dossiers></dossiers></v-card>
      </v-tab-item>
      <v-tab-item v-if="activeProfile.role == authority.COMPANY.role">
        <v-card flat><request></request></v-card>
      </v-tab-item>
      <v-tab-item v-if="activeProfile.role === authority.CONSULTANT.role">
        <v-card flat><requests-cons></requests-cons></v-card>
      </v-tab-item>
    </v-tabs>
  </sea-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { authority } from "@/shared/security/authority";
import Generici from "./Documents.vue";
import Dossiers from "./Dossiers.vue";
import Request from "./Request.vue";
import RequestsCons from "./RequestsCons.vue";

export default {
  name: "doc-azi",
  components: {
    Generici,
    Dossiers,
    Request,
    RequestsCons,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.query.codiceAzienda) {
        vm.setCurrentCompany(to.query.codiceAzienda);
        vm.setWCurrentCompany(to.query.codiceAzienda);
      }
    });
  },
  data() {
    return { active: null, authority };
  },
  methods: {
    ...mapActions({
      setCurrentCompany: "docsAzi/setCurrentCompany",
      setWCurrentCompany: "widget/setCurrentCompany",
      fetchList: "docsAzi/fetchDossiers",
    }),
    clickTab(){
      console.log("clickTab");
      this.fetchList();
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "account/authenticated",
      account: "account/account",
      activeProfile: "account/activeProfile",
    }),
  },

  mounted() {
    this.active = parseInt(localStorage.getItem("current_tab_docs_azi"));
  },
  watch: {
    active() {
      localStorage.setItem("current_tab_docs_azi", this.active);
    },
    "$route.query.codiceAzienda"() {
      this.$router.go();
    },
  },
};
</script>

<style>
</style>